import React from 'react';
import { Navigate } from 'react-router-dom';
import apiService from '../services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const isAuthenticated = apiService.isAuthenticated();
  const user = apiService.getCurrentUser();
  const userType = user?.userType || '';

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if route has role restrictions
  if (allowedRoles && allowedRoles.length > 0) {
    // Check if user's role is in the allowed roles
    if (!allowedRoles.includes(userType)) {
      // Redirect to appropriate home page based on role
      if (userType === 'admin') {
        return <Navigate to="/dashboard" replace />;
      } else if (userType === 'company_manager') {
        return <Navigate to="/company-dashboard" replace />;
      }
      return <Navigate to="/complaints" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
